import React, { useState, useEffect, useRef }  from 'react';
import { HiOutlineMailOpen } from "react-icons/hi";
import { IoCloudDownloadOutline } from "react-icons/io5";
import { IoPrintOutline } from "react-icons/io5";
import { usePDF } from "react-to-pdf";
import axios from 'axios';
// import AsyncStorage from '@react-native-async-storage/async-storage';
import Swal from 'sweetalert2';
import { useLocation, useNavigate } from 'react-router-dom';
// import PaymentDash from '../../Payment Dashboard/PaymentDash';
import { ToWords } from 'to-words';
// import { BASE_URL } from '../../api/api';
import { BASE_URL } from '../../../Components/Styles/API/API';
import classes from './NewCheque.module.css';
// import EcobankLogo from '../../../assets/logo-ecobank.png';
 // Ensure you have the logo image in the specified path
 import EcobankLogo from "../../../Assets/logo-ecobank.png";
 import HeaderNav from "../../Accoungting/HeaderNav/HeaderNav";
 import BackLogo from "../../../Assets/back.svg"

export default function NewCheque() {
 const navigate = useNavigate();
  const [banks, setBanks] = useState([]);
  const [bankLoading, setBankLoading] = useState(false);
  const [chequeLoading, setChequeLoading] = useState(false);
  const [selectedBank, setSelectedBank] = useState('');
  const [bearer, setBearer] = useState('');
  const [description, setDescription] = useState('');
  const [beneficiary1, setBeneficiary1] = useState('');
  const [beneficiary, setBeneficiary] = useState('');
  const [totalAmount, setTotalAmount] = useState('');
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [email, setEmail] = useState("");
  const printRef = useRef();

  const { toPDF, targetRef } = usePDF({
    filename: "cheque.pdf",
  });
  const [printed, setPrinted] = useState(false);
  const [totalNetPayInWords, setTotalNetPayInWords] = useState('');
  const location = useLocation();
//  const { selectedData = [], selectedBank = "" } = location.state || {};
const {invoice } = location.state || {};
console.log(invoice, "datafull");
  const toWords = new ToWords({
    localeCode: 'en-US',
    converterOptions: {
      currency: true,
      ignoreDecimal: false,
      ignoreZeroCurrency: false,
      doNotAddOnly: false,
      currencyOptions: {
        name: 'Naira',
        plural: 'Naira',
        //   name: vouchers?.vouchers[0]?.currency?.currency,
        //   plural: vouchers?.vouchers[0]?.currency?.currency,
        //   symbol: vouchers?.vouchers[0]?.currency?.symbol,
        fractionalUnit: {
          name: 'Kobo',
          plural: 'Kobo',
          // symbol: '',
        },
      }
    }
  });





  const convertToWords = (number) => {
    // Check if number is not a valid number
    if (isNaN(number) || number === '' || number === null) {
      return 'Invalid number';
    }

    const units = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
    const teens = [
      '',
      'Eleven',
      'Twelve',
      'Thirteen',
      'Fourteen',
      'Fifteen',
      'Sixteen',
      'Seventeen',
      'Eighteen',
      'Nineteen',
    ];
    const tens = ['', 'Ten', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];
    const suffixes = ['', 'Thousand', 'Million', 'Billion', 'Trillion'];
    const numToWords = (num) => {
      if (num === 0) return '';
      if (num < 10) return units[num];
      if (num < 20) return teens[num - 10];
      if (num < 100) return tens[Math.floor(num / 10)] + (num % 10 !== 0 ? ' ' + units[num % 10] : '');
      if (num < 1000)
        return units[Math.floor(num / 100)] + ' Hundred' + (num % 100 !== 0 ? ' ' + numToWords(num % 100) : '');
      for (let i = 1; i <= 4; i++) {
        if (num < Math.pow(1000, i + 1)) {
          return numToWords(Math.floor(num / Math.pow(1000, i))) + ' ' + suffixes[i] +
            (num % Math.pow(1000, i) !== 0 ? ' ' + numToWords(num % Math.pow(1000, i)) : '');
        }
      }
      return 'Number too large to convert';
    };

    const [integerPart, decimalPart] = number.toFixed(2).split('.');
    const integerWords = parseInt(integerPart, 10) !== 0 ? numToWords(parseInt(integerPart, 10)) + ' Naira' : '';
    const decimalWords = parseInt(decimalPart, 10) !== 0 ? ' ' + numToWords(parseInt(decimalPart, 10)) + ' Kobo' : '';

    const result = (integerWords + (integerWords && decimalWords ? ',' : '') + decimalWords).trim();

    return result;
  };

  console.log(invoice, "here");


  const readData = async () => {
    try {
      const value = await localStorage.getItem('userToken');

      if (value !== null) {
        setBearer(value);
        // setAuthenticated(true);
      }
    } catch (e) {
      alert('Failed to fetch the input from storage');
    }
  };

  useEffect(() => {
    readData();
  }, []);

  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${bearer}`
  };

  const handleGoBack = () => {
    navigate(-1);
  }

console.log(invoice, "selectedData");

const handlePrint = async () => {
  if (printed) {
    window.print();
    return;
  }

  const result = await Swal.fire({
    title: "Are you sure?",
    text: "Do you want to print this cheque?",
    icon: "question",
    showCancelButton: true,
    confirmButtonText: "Yes, Print",
    cancelButtonText: "Cancel",
  });

  if (!result.isConfirmed) return;

  Swal.fire({
    title: "Please wait",
    text: "Your cheque is being processed for printing...",
    allowOutsideClick: false,
    didOpen: () => {
      Swal.showLoading();
    },
  });

  const ids = invoice.uuid;
  const amounts = invoice.amount;
  const bank = invoice.bank_lodged?.id;
  const description = invoice.description;

  try {
    await axios.post(
      `${BASE_URL}/pay_bulk_payables`,
      {
        uuid: ids,
        amount: amounts,
        payment_bank: bank,
        payment_description: description,
      },
      { headers }
    );

    Swal.close();
    setPrinted(true);

    // ✅ Wait a short moment for DOM repaint before printing
    setTimeout(() => {
      window.print();
    }, 300); // 300ms is usually enough (you can tweak to 200–500ms)

  } catch (error) {
    Swal.close();
    let errorMessage = "An error occurred. Please try again.";

    if (error.response?.data?.message) {
      if (typeof error.response.data.message === "string") {
        errorMessage = error.response.data.message;
      } else if (Array.isArray(error.response.data.message)) {
        errorMessage = error.response.data.message.join("; ");
      } else if (typeof error.response.data.message === "object") {
        errorMessage = JSON.stringify(error.response.data.message);
      }
    }

    Swal.fire({
      icon: "error",
      title: "Failed",
      text: errorMessage,
    });
    console.error(errorMessage);
  }
};









  const today = new Date();

  // Format as DD-MM-YYYY
  const day = String(today.getDate()).padStart(2, "0"); // ensures 2 digits
  const month = String(today.getMonth() + 1).padStart(2, "0"); // months are 0-based
  const year = String(today.getFullYear());

  // Combine
  const formattedDate = `${day}-${month}-${year}`;
  const dateDigits = formattedDate.split(""); 


  // const supplierName = invoice.supplier?.name.toUpperCase();
  // const customerName = invoice?.particular.toUpperCase();
  const sum =  invoice.amount;
  
  const handleSendEmail = () => {
    Swal.fire("Sent!", `Payment instruction sent to ${email}`, "success");
    setShowEmailModal(false);
  };

  //   useEffect(() => {
  //   const handleKeyDown = (e) => {
  //     // Detect Ctrl+P (Windows/Linux) or Cmd+P (Mac)
  //     if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === "p") {
  //       e.preventDefault();
  //       e.stopPropagation();
  //       alert("Please use the Print button on the page instead of Ctrl+P");
  //     }
  //   };

  //   window.addEventListener("keydown", handleKeyDown);
  //   return () => {
  //     window.removeEventListener("keydown", handleKeyDown);
  //   };
  // }, []);

  

  return (
    <div style={{ backgroundColor: "#f9f9f9", minHeight: "100vh" }}>
      <HeaderNav />

      <div className={classes.topContainer}>

      <div className={classes.backTxt}>
          <img src={BackLogo} alt="back" className={classes.iconBtn}  onClick={() => navigate(-1)} />
          <div className={classes.bckText}>
            <h3 className={classes.topText}>Cheque Payments</h3>
            {/* <IoPrintOutline className={classes.icon} onClick={handlePrint} /> */}
          </div>
        </div>
     
    <div className={classes.container}>
     <div className={classes.header}>
    {/* <div className={classes.iconRow}>
      <h2 className={classes.headerTitle}>CHEQUE PAYMENTS</h2>
    </div> */}
      <IoPrintOutline className={classes.icon} onClick={handlePrint} />   
  </div>
  {/* {invoice.map((item, index) => ( */}
      <div key={invoice.id} style={{ marginBottom: "60px" }}  className={classes.cheque} ref={printRef}>
        {/* Address */}
        <div className={classes.chequeNumber}>{invoice?.teller_number || '4981772420'}</div>
        <div className={classes.topRow} >
        <div className={classes.address}>
         {/* <p className={classes.addressTxt}> 302, HERBERT MACAULAY WAY
          <br />
          SABO YABA, LAGOS
          </p> */}
        </div>

        {/* Bank Name and Logo */}
        
          {/* <img src={EcobankLogo} className={classes.imgLogo} alt="Ecobank Logo"  /> */}
      

        {/* Cheque Number */}
        

        {/* Date Box */}
       <div className={classes.dateBox}>
      {/* Day */}
      <div className={classes.section}>
        <div className={classes.dateLabel}>Day</div>
        {dateDigits.slice(0, 2).map((digit, index) => (
          <div key={index} className={classes.digitBox}>
            {digit}
          </div>
        ))}
      </div>

      {/* Month */}
      <div className={classes.section}>
        <div className={classes.dateLabel}>Month</div>
        {dateDigits.slice(3, 5).map((digit, index) => (
          <div key={index + 2} className={classes.digitBox}>
            {digit}
          </div>
        ))}
      </div>

      {/* Year */}
      <div className={classes.section}>
        <div className={classes.dateLabel}>Year</div>
        {dateDigits.slice(6).map((digit, index) => (
          <div key={index + 4} className={classes.digitBox}>
            {digit}
          </div>
        ))}
      </div>
    </div>

</div>
        {/* Pay to Line */}
        <div style={{marginTop: 10}} />
        <div className={classes.payTo}>
          <p className={classes.payToLabel}>Pay to</p>
          
          <p className={classes.payToValue}>{invoice?.particular}</p>
       {/* <hr className={classes.payToLine} /> */}

        </div>

  <div className={classes.sumOf}>
  <p className={classes.sumOfLabel}>The sum of</p>
   <p className={classes.sumOfLabelValue}>{invoice?.amount ? toWords.convert(parseFloat(invoice?.amount)) : ""}</p>
  {/* <hr className={classes.sumOfLine} /> */}
</div>
    
        {/* Amount Prefix */}
        <div className={classes.amountBox}>
        <p className={classes.amountPrefix}>₦</p>
        <div className={classes.inputBox}>{parseFloat(invoice?.amount).toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}</div>
</div>
        {/* Account Details */}
        <div className={classes.accountDetails}>
          THE  REDEEMED CHRISTIAN 
          <br />
         CHURCH OF GOD
        </div>
      </div>
      {/* ))} */}
    </div>
    </div>
    </div>
  );
}